module.exports = __webpack_public_path__ + "static/media/account.5b84f83b.svg";